import { Link } from 'react-router-dom';
import { clsx } from 'clsx';
import { useGlobalQueries } from '@/hooks/use-global-queries';
import { useNavItem } from '@/hooks/use-nav-item';
import { useNavMenus } from '@/hooks/use-nav-menus';
import { useLocalization } from '@/hooks/use-localization';

export const TopMenu = () => {
    const { getTopMenuItems } = useNavMenus();
    const { isCurrentItemActive } = useNavItem();
    const { getMarketType } = useGlobalQueries();
    const { localize } = useLocalization();
    const { marketMenu, mainMenu } = getTopMenuItems();
    const STANDARD_LIST_STYLE = 'r-py-1 r-px-2 r-font-semibold';

    if (getMarketType() === 'cluster') {
        return null;
    }

    return (
        <div data-component="top-menu" className="r-bg-tertiary-500 r-text-white">
            <nav aria-label={localize('secondary-menu')} className="r-container r-flex r-justify-between r-px-8 r-py-2 r-align-middle">
                <ul className="r-flex r-gap-3">
                    {marketMenu.map((item, index) => (
                        <li
                            key={index}
                            className={clsx(
                                STANDARD_LIST_STYLE,
                                'r-rounded-xl r-transition-all hover:r-bg-white hover:r-text-tertiary-500 active:r-bg-white active:r-text-tertiary-500',
                                {
                                    'r-bg-white r-text-tertiary-500': item.market_type === getMarketType(),
                                }
                            )}
                        >
                            <Link className="r-py-1.5" to={item.url.replace(/\/$/, '')} target={item.target || '_self'}>
                                {item.title}
                            </Link>
                        </li>
                    ))}
                </ul>

                <ul className="-r-mr-2 r-flex r-gap-6">
                    {mainMenu.map((item, index) => (
                        <li
                            key={index}
                            className={clsx(STANDARD_LIST_STYLE, 'r-rounded-xl r-transition-all hover:r-bg-white hover:r-text-tertiary-500', {
                                'r-bg-white r-text-tertiary-500': isCurrentItemActive(item),
                            })}
                        >
                            <Link className="r-py-1.5" to={item.url.replace(/\/$/, '')} target={item.target || '_self'}>
                                {item.title}
                            </Link>
                        </li>
                    ))}
                </ul>
            </nav>
        </div>
    );
};
